/**
 * UPMI (PROMAG300) bespoke storefront design tokens — from the handoff Design
 * Tokens (deep teal). Shared by the shell + all upmi pages so the palette stays
 * in one place. Hardcoded hex (like the mhyel landing) — the bespoke pages own
 * their look; the runtime theme only drives the shared/marketplace surfaces.
 */
export const O = '#0d5959'; // accent
export const OD = '#0a4444'; // dark
export const OL = '#e4efee'; // light tint
export const OGRAD = 'linear-gradient(135deg,#2fa89a,#12807a 45%,#0d5959)';
export const VIDEO_BG = '#0a4545';
export const GOLD = '#e0a100';
export const INK = '#222';
export const MUTED = '#767676';
export const LINE = '#ececec';
export const PAGE = '#f5f5f5';
export const CARD = '#fff';
export const GR_INK = '#1c7a4d';
export const GR_L = '#eefaf2';
export const GR_BD = '#c7ecd7';

export const LOGO = '/tenants/upmi-logo.png';

/**
 * Public media base — the storefront media (brand video + gallery/testimonial/
 * about imagery + icons) is committed under `apps/member/public/tenants/upmi/`
 * and shipped with the app, same as agp/flx, so it is served from the tenant's
 * OWN domain by Caddy.
 *
 * This used to point at the `upmi-media` bucket's public `pub-….r2.dev` URL.
 * That broke the client outright: `r2.dev` is Cloudflare's development-only
 * endpoint (rate-limited, and widely blocklisted by ISP/DNS filters and AV web
 * shields because public R2 buckets get abused for phishing), so their network
 * could not reach it from any device while the rest of the site loaded fine.
 * Serving from our own origin removes the third-party hostname entirely — don't
 * reintroduce an external media host here.
 *
 * `VITE_MEDIA_URL` remains an optional build-time override if the assets ever
 * move to a real CDN on a first-party domain.
 * Reference as e.g. `${MEDIA}/homebannervideo.mp4`, `${MEDIA}/gallery/image1.jpg`.
 */
export const MEDIA =
  (import.meta.env.VITE_MEDIA_URL as string | undefined)?.replace(/\/+$/, '') || '/tenants/upmi';

export const SOCIAL = {
  facebook: 'https://facebook.com/Promag300PremierOfficial',
  instagram: 'https://instagram.com/promag300premierofficial',
  tiktok: 'https://tiktok.com/@promag300premierofficial',
  shopee: 'https://shopee.ph/ultraproactive2014',
  lazada: 'https://lazada.com.ph/shop/ultra-proactive-marketing',
};

export const fmtPrice = (n: number) =>
  `₱${n.toLocaleString('en-PH', { minimumFractionDigits: 2 })}`;
